"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _TierPreview = _interopRequireDefault(require("@mulesoft/client-applications-ui/raw/components/TierPreview"));
var styles = {
  "tier-limits-table": "APIGroupSLATierLimits__tier-limits-table__1SknT",
  "tierLimitsTable": "APIGroupSLATierLimits__tier-limits-table__1SknT",
  "disclaimer": "APIGroupSLATierLimits__disclaimer__k0Xk-"
}; 
require('./APIGroupSLATierLimits.css');
var renderEmptyTier = function renderEmptyTier() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.disclaimer,
    "data-test-id": "api-group-no-sla-tier-limits"
  }, "The selected SLA tier does not display information for any public instance");
};
var renderLimits = function renderLimits(_ref) {
  var limitsByAPI = _ref.limitsByAPI;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tierLimitsTable,
    "data-test-id": "api-group-sla-tier-limits"
  }, limitsByAPI.map(function (_ref2, index) {
    var limits = _ref2.limits,
      name = _ref2.name,
      instanceName = _ref2.instanceName;
    return /*#__PURE__*/_react.default.createElement(_TierPreview.default
    /* eslint-disable-next-line react/no-array-index-key */, {
      key: index,
      title: "".concat(name, " - ").concat(instanceName),
      limits: (limits || []).map(function (_ref3) {
        var timeUnit = _ref3.timeUnit,
          timePeriod = _ref3.timePeriod,
          maximumRequests = _ref3.maximumRequests;
        return {
          maximumRequests: maximumRequests,
          period: timePeriod,
          unit: timeUnit
        };
      })
    });
  }));
};
var APIGroupSLATierLimits = function APIGroupSLATierLimits(props) {
  var limitsByAPI = props.limitsByAPI;
  return limitsByAPI.length > 0 ? renderLimits({
    limitsByAPI: limitsByAPI
  }) : renderEmptyTier();
};
var _default = exports.default = APIGroupSLATierLimits;
//# sourceMappingURL=APIGroupSLATierLimits.js.map